import React from 'react';
import { Menu } from 'evergreen-ui';

const HospitalCapabilityMenu = ({ onEditClick, onDeleteClick }: any) => {
  return (
    <Menu>
      <Menu.Group>
        <Menu.Item onSelect={onEditClick}>Edit capability</Menu.Item>
      </Menu.Group>
      <Menu.Divider />
      <Menu.Group>
        <Menu.Item intent="danger" onSelect={onDeleteClick}>
          Delete capability
        </Menu.Item>
      </Menu.Group>
    </Menu>
  );
};

export default HospitalCapabilityMenu;
